/**
 * A product's level scheme as MyBestUser defines it. The stored level is always the raw
 * number — these fields only decide what the teacher reads next to it.
 */
export interface ProductLevelScheme {
  maxLevel: number;
  levels: number[];
  baseLevel?: string | null;
  isCustomLevel: boolean;
  customLevels: string[];
}

/**
 * What MyBestUser calls this level. Classroom placements are named the same way there, so
 * a teacher tagging content sees the words the school admin sees.
 */
export function productLevelLabel(product: ProductLevelScheme, level: number): string {
  if (level === 0) return product.baseLevel || "Base";
  if (product.isCustomLevel) return product.customLevels[level - 1] ?? String(level);
  return String(level);
}

/**
 * Levels a project may be tagged with, in order. Falls back to 1..maxLevel for a product
 * whose scheme MyBestUser hasn't filled in.
 */
export function productLevelOptions(product: ProductLevelScheme): number[] {
  if (product.levels.length > 0) return [...product.levels].sort((a, b) => a - b);
  return Array.from({ length: product.maxLevel }, (_, i) => i + 1);
}
